import React from 'react';
import '../less/index.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import CardOrderModal from '../../../../../auxiliary-components/CardOrderModal';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../../../auxiliary-components/shared/TextAboveFooterNew";
import FAQStorybook from '@abank/abank-faq';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additional_product_img_1 from '../img/additional_product_img_1.png';
import additional_product_img_2 from '../img/additional_product_img_2.png';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import how_to_block_img_4 from '../img/how_to_block_img_4.png';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import CalculatorNew from '../../../../../auxiliary-components/CalculatorNew';
import { Preloader } from 'MWComponents';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const model = this.getModel();
    const page = 'credit-vygoda-new';

    const tabs = [{tab: 'get-services', title: 'CREDIT_VYGODA_NEW_TABS_TITLE_01'},
      {tab: 'calculator', title: 'CREDIT_VYGODA_NEW_TABS_TITLE_02'},
      {tab: 'payments', title: 'CREDIT_VYGODA_NEW_TABS_TITLE_03'}];

    const hero_data = {
      title: 'CREDIT_VYGODA_NEW_HERO_TITLE',
      text: 'CREDIT_VYGODA_NEW_HERO_TEXT',
      link: {
        text: "CREDIT_VYGODA_NEW_HERO_BTN",
        onClick: () => this.toggleModal(),
      },
      cards: [
        {
          title: 'CREDIT_VYGODA_NEW_CARDS_HERO_TITLE_01',
          text: 'CREDIT_VYGODA_NEW_CARDS_HERO_TEXT_01',
        },
        {
          title: 'CREDIT_VYGODA_NEW_CARDS_HERO_TITLE_02',
          text: 'CREDIT_VYGODA_NEW_CARDS_HERO_TEXT_02',
        },
        {
          title: 'CREDIT_VYGODA_NEW_CARDS_HERO_TITLE_03',
          text: 'CREDIT_VYGODA_NEW_CARDS_HERO_TEXT_03',
        }
      ]
    };

    const additionalCards = [
      {
        img: additional_product_img_1,
        link: '/cards/vygoda',
        title: 'CREDIT_VYGODA_NEW_CARDS_ADDITIONAL_PRODUCT_TITLE_01',
        text: 'CREDIT_VYGODA_NEW_CARDS_ADDITIONAL_PRODUCT_TEXT_01',
        textBtn: 'CREDIT_VYGODA_NEW_CARDS_ADDITIONAL_PRODUCT_LINK_01',
      },
      {
        img: additional_product_img_2,
        link: '/cards/atb',
        title: 'CREDIT_VYGODA_NEW_CARDS_ADDITIONAL_PRODUCT_TITLE_02',
        text: 'CREDIT_VYGODA_NEW_CARDS_ADDITIONAL_PRODUCT_TEXT_02',
        textBtn: 'CREDIT_VYGODA_NEW_CARDS_ADDITIONAL_PRODUCT_LINK_02',
      }
    ];

    const howToBlockItems = [
      {
        img: how_to_block_img_1,
        title: 'CREDIT_VYGODA_NEW_HOW_TO_TITLE_01',
        text: 'CREDIT_VYGODA_NEW_HOW_TO_TEXT_01',
        link: {
          text: "CREDIT_VYGODA_NEW_HOW_TO_LINK_01",
          onClick: () => this.toggleModal(),
        },
        reversedImg: true
      },
      {
        img: how_to_block_img_2,
        title: 'CREDIT_VYGODA_NEW_HOW_TO_TITLE_02',
        text: 'CREDIT_VYGODA_NEW_HOW_TO_TEXT_02',
      },
      {
        img: how_to_block_img_3,
        title: 'CREDIT_VYGODA_NEW_HOW_TO_TITLE_03',
        text: 'CREDIT_VYGODA_NEW_HOW_TO_TEXT_03',
      },
      {
        img: how_to_block_img_4,
        title: 'CREDIT_VYGODA_NEW_HOW_TO_TITLE_04',
        text: 'CREDIT_VYGODA_NEW_HOW_TO_TEXT_04',
      }
    ];

    const advantagesItems = [
      {
        title: 'CREDIT_VYGODA_NEW_CARDS_ADVANTAGES_TITLE_01',
        text: 'CREDIT_VYGODA_NEW_CARDS_ADVANTAGES_TEXT_01',
      },
      {
        title: 'CREDIT_VYGODA_NEW_CARDS_ADVANTAGES_TITLE_02',
        text: 'CREDIT_VYGODA_NEW_CARDS_ADVANTAGES_TEXT_02',
      },
    ];

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
        <div className="credit-vygoda-new">
          <Hero
            data={hero_data}
            img={hero_img}
            page={page}
          />
          <div className="content">
            {!this.state.faqTab ? (
              <>
                <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} isMobile={this.state.isMobile} page={page}>
                  <HowToBlockNew
                    items={howToBlockItems}
                  />
                  {model.creditSum ? (
                    <CalculatorNew model={model} type={this.state.selectedType} {...this.props} tab={this.state.tab}/>
                  ) : <Preloader />}
                  <Advantages
                    items={advantagesItems}
                  />
                </Tabs>
                <AdditionalProduct
                  items={additionalCards}
                  title={'CREDIT_VYGODA_NEW_ADDITIONAL_PRODUCT_TITLE'}
                  page={page}
                />
                <QuestionsAdminNew
                  widget={questionsWidget}
                  toggleFaqTab={this.toggleFaqTab}
                  title={'FAQ_SHORT_NEW_TITLE'}
                  page={page}
                />
                <FilesForDownloadNew
                  widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
                />
                <TextAboveFooterNew
                  widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
                />
              </>
            ) : (
              <FAQStorybook
                widget={questionsWidget}
                title={this.l10n('CREDIT_VYGODA_NEW_FAQ_STORYBOOK_TITLE')}
                btnText={this.l10n('CREDIT_VYGODA_NEW_FAQ_STORYBOOK_BTN_TEXT')}
                onBtnClick={this.toggleFaqTab}
                filterByEnvironment={filterByEnvironment}
              />
            )}
          </div>
          {this.state.showModal ? 
            <CardOrderModal closeModal={this.toggleModal} product={"vygoda"} isOpen={this.state.showModal}/> : ''
          }
        </div>
    );
}
